/**
 * Semaforo de vigencia de certificados (FIEL / CSD).
 * Viven aqui y no en el componente para no romper Fast Refresh:
 * un archivo que exporta componentes no debe exportar tambien constantes.
 */

export const CERT_INDICADOR_COLORS = {
  none: '#1a1a1a',
  ok: '#198754',
  warning: '#ffc107',
  danger: '#dc3545',
}

export const CERT_INDICADOR_LABELS = {
  none: 'Sin certificado',
  ok: 'Vigente (>45 días)',
  warning: 'Vence en ≤45 días',
  danger: 'Vence en ≤20 días o vencido',
}
